const LIMIT_XHR_REQUEST_COUNT = 200;
let CurrentRequestCount = 0;

const common = {
  LIMIT_XHR_REQUEST_COUNT,
  CurrentRequestCount
};
export default common;
